<template>
  <div class="confirmOrder">
    <div class="container">
      <div class="titleNav">
        <a href="">我要下单</a> /
        <router-link to="/cityExpress">快递服务</router-link> /
        <a href="">确定订单</a>
      </div>
      <div class="info">
        <div class="top">
          <div class="left">
            <table>
              <tr>
                <td>寄件人姓名</td>
                <td>{{expressInfo.sendName}}</td>
              </tr>
              <tr>
                <td>寄件人电话</td>
                <td>{{expressInfo.sendMobile}}</td>
              </tr>
              <tr>
                <td>寄件人地址</td>
                <td>{{expressInfo.sendAddress}}{{expressInfo.sendAddressInfo}}</td>
              </tr>
              <tr>
                <td>收件人姓名1</td>
                <td>{{expressInfo.getName1}}</td>
              </tr>
              <tr>
                <td>收件人电话1</td>
                <td>{{expressInfo.getMobile1}}</td>
              </tr>
              <tr>
                <td>收件人地址1</td>
                <td>{{expressInfo.getAddress1}}{{expressInfo.getAddressInfo1}}</td>
              </tr>
              <tr v-if="expressInfo.getName2">
                <td>收件人姓名2</td>
                <td>{{expressInfo.getName2}}</td>
              </tr>
              <tr v-if="expressInfo.getName2">
                <td>收件人电话2</td>
                <td>{{expressInfo.getMobile2}}</td>
              </tr>
              <tr v-if="expressInfo.getName2">
                <td>收件人地址2</td>
                <td>{{expressInfo.getAddress2}}{{expressInfo.getAddressInfo2}}</td>
              </tr>
              <tr v-if="expressInfo.getName3">
                <td>收件人姓名3</td>
                <td>{{expressInfo.getName3}}</td>
              </tr>
              <tr v-if="expressInfo.getName3">
                <td>收件人电话3</td>
                <td>{{expressInfo.getMobile3}}</td>
              </tr>
              <tr v-if="expressInfo.getName3">
                <td>收件人地址3</td>
                <td>{{expressInfo.getAddress3}}{{expressInfo.getAddressInfo3}}</td>
              </tr>
              <tr>
                <td>物品名称</td>
                <td>{{expressInfo.goodsName}}</td>
              </tr>
              <tr>
                <td>物品重量</td>
                <td>{{expressInfo.goodsWeight}}KG</td>
              </tr>
              <tr>
                <td>取件时间</td>
                <td>{{expressInfo.getGoodsDate}}</td>
              </tr>
              <tr>
                <td>备注信息</td>
                <td>{{expressInfo.description}}</td>
              </tr>
              <tr v-if="this.expressType == 1">
                <td>快递</td>
                <td>{{expressInfo.expressTypes}}</td>
              </tr>
              <tr v-if="this.expressType == 1">
                <td>付款方式</td>
                <td>{{expressInfo.payMethod}}</td>
              </tr>
            </table>
          </div>
          <div class="right">
            <raise-price></raise-price>
          </div>
        </div>
        <div class="bottom">
          <router-link :to="{name: 'RichText', query: {code: '009'}}" class="plain">价格说明</router-link>
          <price-explain ></price-explain>
        </div>
        <button class="payBtn" @click="pay">支付</button>
      </div>
    </div>
    <pay-way v-if="isShowPay" @close="showPay"/>
  </div>
</template>

<script>
import RaisePrice from '../../../components/Courier/RaisePrice'
import PriceExplain from '../../../components/Courier/PriceExplain'
import PayWay from '../../../components/Pay/PayWay'
import {reqOrderCity, reqOrderDomestic, reqCountCityExpressFee, reqCountStateExpressFee} from '../../../api'
import {mapState} from 'vuex'
export default {
  data() {
    return {
      // expressInfo: {},
      info: {
        addFee: '',
        couponId: ''
      },
      isShowPay: false
    }
  },
  created() {
    if(JSON.stringify(this.expressInfo) === '{}'){
      this.$router.go(-1)
    }
  },
  methods: {

    // 显示支付方式
    showPay () {
      this.isShowPay = !this.isShowPay
    },
    // 支付
    pay () {
      // let json = eval('('+(JSON.stringify(this.expressInfo)+JSON.stringify({addFee: this.addFee, couponId: this.amount.couponId, origin:1})).replace(/}{/,',')+')')

      if(this.expressType) {
        let json = {
          addFee: this.addFee,
          couponId: this.amount.couponId,
          description: this.expressInfo.description,
          expressType: this.expressInfo.expressTypes,
          getAddress: this.expressInfo.getAddress1,
          getAddressInfo: this.expressInfo.getAddressInfo1,
          getGoodsDate: this.expressInfo.getGoodsDate,
          getMobile: this.expressInfo.getMobile1,
          getName: this.expressInfo.getName1,
          goodsName: this.expressInfo.goodsName,
          goodsWeight: this.expressInfo.goodsWeight,
          origin: 1,
          payMethod: this.expressInfo.payMethod,
          sendAddress: this.expressInfo.sendAddress,
          sendAddressInfo: this.expressInfo.sendAddressInfo,
          sendMobile: this.expressInfo.sendMobile,
          sendName: this.expressInfo.sendName,
        }
        reqOrderDomestic(json).then(res => {
          if(res.code === 200) {
            this.showPay()
            this.$store.dispatch('getOrderInfo', res.data.bussData)
          }
        })
      } else {
        let json = Object.assign(this.expressInfo, {addFee: this.addFee, couponId: this.amount.couponId, origin:1})
        reqOrderCity(json).then(res => {
          if(res.code === 200) {
            this.showPay()
            this.$store.dispatch('getOrderInfo', res.data.bussData)
          }
        })
      }
    }
  },
  computed: {
    ...mapState(['expressInfo', 'expressType', 'amount', 'addFee'])
  },
  components: {
    RaisePrice,
    PriceExplain,
    PayWay
  }
}
</script>

<style scoped lang="less" type="text/less">
.confirmOrder{
  margin-bottom: 30px;
  .titleNav{
    margin:30px 0;
  }
  .info{
    padding:30px;
    box-shadow:0px 3px 9px 0px rgba(0, 0, 0, 0.09);
    .top{
      overflow: hidden;
      margin-bottom: 40px;
      .left{
        float: left;
        margin-right:30px;
        table{
          /*border:1px solid #e1e1e1;*/
          td{
           border:1px solid #e1e1e1;
            &:first-of-type{
              width: 129px;
              height: 40px;
              line-height: 40px;
              text-indent: 20px;
            }
            &:last-of-type{
              width: 440px;
              height: 40px;
              line-height: 40px;
              text-indent: 30px;
            }
          }
        }
      }
      .right{
        float: left;
        width: 534px;
      }
    }
    .bottom{
      padding-top:29px;
      border-top:1px solid #e1e1e1;
      .plain{
        color:#2FA1DE;
        text-decoration: underline;
      }
    }
    .payBtn{
      display: block;
      width: 323px;
      height: 48px;
      margin:30px 0 85px 240px;
      background: #61AEE6;
      font-size: 18px;
      color:#fff;
      border:none;
      border-radius: 24px;
      cursor: pointer
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Courier/Express/ConfirmOrder.vue